import { useState } from "react";
import { formatDate, formatTRY } from "@/lib/api";
import { FileText, Wallet, HandCoins, MessageCircle, Tag, Archive, FilePen } from "lucide-react";

const KINDS = {
  policy: { label: "Poliçe", icon: FileText, cls: "bg-emerald-100 text-emerald-700" },
  zeyil: { label: "Zeyil", icon: FilePen, cls: "bg-sky-100 text-sky-700" },
  quote: { label: "Teklif", icon: Tag, cls: "bg-violet-100 text-violet-700" },
  debt: { label: "Borç", icon: Wallet, cls: "bg-rose-100 text-rose-700" },
  payment: { label: "Ödeme", icon: HandCoins, cls: "bg-teal-100 text-teal-700" },
  whatsapp: { label: "WhatsApp", icon: MessageCircle, cls: "bg-green-100 text-green-700" },
  archive: { label: "Arşiv", icon: Archive, cls: "bg-zinc-200 text-zinc-600" },
};
const FILTERS = [["all", "Tümü"], ["policy", "Poliçeler"], ["money", "Ödemeler"], ["whatsapp", "WhatsApp"], ["quote", "Teklifler"]];
const match = (f, k) => f === "all" || (f === "money" ? k === "debt" || k === "payment" : f === "policy" ? ["policy", "zeyil", "archive"].includes(k) : f === k);

const Event = ({ e, i }) => {
  const K = KINDS[e.kind] || KINDS.policy;
  const [open, setOpen] = useState(false);
  const long = (e.sub || "").length > 140;
  return (
    <li className="relative pl-10 pb-5" data-testid={`timeline-event-${i}`}>
      <span className={`absolute left-0 top-0 grid place-items-center h-7 w-7 rounded-full ring-4 ring-white ${K.cls}`}><K.icon className="h-3.5 w-3.5" /></span>
      <div className="flex items-baseline justify-between gap-3">
        <p className="text-sm font-medium text-zinc-900">{e.title}</p>
        {e.amount != null && e.amount !== 0 && (
          <span className={`shrink-0 font-mono text-sm ${e.kind === "payment" ? "text-teal-700" : e.kind === "debt" ? "text-rose-700" : "text-zinc-700"}`}>
            {e.kind === "payment" ? "+" : ""}{formatTRY(e.amount)}
          </span>
        )}
      </div>
      <p className="text-[11px] text-zinc-400 mt-0.5">{formatDate(e.date)}{e.date?.length > 10 ? ` · ${e.date.slice(11, 16)}` : ""}</p>
      {e.sub && (
        <p className={`text-xs text-zinc-600 mt-1 whitespace-pre-line ${long && !open ? "line-clamp-2" : ""}`}>
          {e.sub}
        </p>
      )}
      {long && <button type="button" onClick={() => setOpen((o) => !o)} className="text-[11px] text-emerald-700 hover:underline mt-0.5">{open ? "Daha az" : "Devamını gör"}</button>}
    </li>
  );
};

export const CustomerTimeline = ({ events }) => {
  const [f, setF] = useState("all");
  const rows = events.filter((e) => match(f, e.kind));
  return (
    <div data-testid="customer-timeline">
      <div className="flex flex-wrap gap-1.5 mb-4">
        {FILTERS.map(([k, l]) => {
          const n = events.filter((e) => match(k, e.kind)).length;
          return (
            <button key={k} type="button" onClick={() => setF(k)} data-testid={`timeline-filter-${k}`}
              className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${f === k ? "bg-zinc-900 text-white" : "bg-zinc-100 text-zinc-600 hover:bg-zinc-200"}`}>
              {l} <span className="opacity-60">{n}</span>
            </button>
          );
        })}
      </div>
      {rows.length === 0 ? <p className="text-sm text-zinc-400 py-6" data-testid="timeline-empty">Bu başlıkta kayıt yok.</p> : (
        <ol className="relative before:absolute before:left-[13px] before:top-2 before:bottom-4 before:w-px before:bg-zinc-200">
          {rows.map((e, i) => <Event key={`${e.kind}-${e.ref}-${e.date}-${i}`} e={e} i={i} />)}
        </ol>
      )}
    </div>
  );
};
